module.exports = "<div>\n  <a (click)=\"redirectUrl()\">{{text}}</a>\n</div>\n"